import React from "react";
export const MapZoomContext = React.createContext();
const ZoomStatusOptions = { BellowThreshold: 0, AboveThreshold: 1 };
import { withMapContext } from "./MapContext";

export class MapZoomChange extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      zoomLevel: props.map?.getZoom() || 9,
      zoomStatus: this.getZoomStatus(props.map?.getZoom() || 9),
    };
  }

  componentDidMount() {
    this.props?.map.on("zoomend", this.onZoomChanged);
  }

  getZoomStatus = (newZoomLevel) => {
    return newZoomLevel > this.props?.thresholdZoomLevel
      ? ZoomStatusOptions.AboveThreshold
      : ZoomStatusOptions.BellowThreshold;
  };

  onZoomChanged = () => {
    const newZoomLevel = this.props?.map.getZoom();
    const newZoomStatus = this.getZoomStatus(newZoomLevel);
    if (newZoomStatus !== this.state.zoomStatus) {
      this.setState({ zoomStatus: newZoomStatus, zoomLevel: newZoomLevel });
    }
  };

  componentWillUnmount() {
    this.props?.map.off("zoomend", this.onZoomChanged);
  }
  
  render() {
    const {thresholdZoomLevel} = this.props;
    const {zoomLevel} = this.state;
    return (
      <MapZoomContext.Provider value={{ zoomLevel, thresholdZoomLevel }}>
        {this.props.children}
      </MapZoomContext.Provider>
    );
  }
}

export default withMapContext(MapZoomChange);
